import ReactGA from 'react-ga4';

import type { RouteComponentProps } from 'react-router-dom';

import { action, observable } from 'mobx';

import createContext from 'bz-utilities/hooks/context-v2';

export const [HistoryStoreContext, useHistoryStore] = createContext<HistoryStore>('HistoryStore');

class HistoryStore {
  history!: RouteComponentProps['history'];
  location!: RouteComponentProps['location'];
  match!: RouteComponentProps['match'];
  analyticsEnabled!: boolean;
  offline: boolean = false;

  @observable redirecting: boolean = false;
  @observable hideNavigation: boolean = false;

  @observable currentPath = '/';

  @action.bound
  public push(route: string, isFull?: boolean) {
    if (!!this.offline) {
      window.location = window.location.origin;
      return;
    }
    this.currentPath = route;

    if (isFull) {
      this.history.push(route);
    } else {
      this.history.push(route);
    }

    if (this.analyticsEnabled) {
      const path = route || '/';
      ReactGA.send({ hittype: 'pageview', page: path });
    }
  }

  refresh() {
    this.history.go(0);
  }

  @action.bound
  public replace(route: string) {
    this.history.replace(route);
  }
}

export default HistoryStore;
